import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { getAccessToken } from '@nw/shared/data-access';

interface ProtectedRouteProps extends RouteProps {
  component: React.FC<any>;
}

/**
 * A route wrapper that protects routes and redirects unauthenticated users to the login page,
 * preserving all query parameters.
 *
 * @param {React.ComponentType<any>} component - The component to render if the user is authenticated.
 * @param {...RouteProps} rest - The remaining route props passed to the `Route` component.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps & RouteProps> = ({
  component: Component,
  ...other
}) => {
  const isLoggedIn = getAccessToken() !== undefined;

  return (
    <Route
      {...other}
      render={({ location, ...props }) =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              search: location.search,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
